import type { RealmLaws } from '@pk/shared';

export function lawRows(laws: RealmLaws, t: (k: string, o?: Record<string, unknown>) => string): { key: keyof RealmLaws; label: string; value: string }[] {
  return [
    { key: 'succession', label: t('laws.succession'), value: t(`laws.succession_.${laws.succession}`) },
    { key: 'gender', label: t('laws.gender'), value: t(`laws.gender_.${laws.gender}`) },
    { key: 'crownAuthority', label: t('laws.crownAuthority'), value: t(`laws.crown_.${laws.crownAuthority}`) },
    { key: 'taxCap', label: t('laws.taxCap'), value: `${Math.round(laws.taxCap * 100)}%` },
    { key: 'internalWarsBanned', label: t('laws.internalWars'), value: laws.internalWarsBanned ? t('laws.banned') : t('laws.allowed') },
  ];
}
